export default __webpack_public_path__ + "static/media/benefit4.0a54c1b6.png";